module.exports = __webpack_public_path__ + "img/newbanner.af32b312.jpg";